<template>
  <div class="content">
    <div class="list">
     <div class="title">
        <h2 class="">实时订单统计</h2>
     </div>
      <ul class="wamp">
        <li v-for="(item, index) in headers" :key="index">
          {{ item.display_name }}
        </li>
      </ul>
      <ul class="ul_list">
        <li v-for="(item, index) in rows" :key="index">
          <div v-for="(value, indexs) in item" :key="indexs">{{ value }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  data() {
    return {
      headers: [],
      rows: [],
      height: 0,
    };
  },
  created() {
    // 请求接口
    this.$axios
      .get(
        `${this.$url}/admin/bigpin13`
      )
      .then((res) => {
        let datas = JSON.parse(res.data.split("<\/script>")[1]).data;

        this.headers = datas.cols.filter(
          (item) => item.display_name !== "门店名称"
        );
        this.rows = datas.rows.map((item) =>
          item.filter((value, index) => index !== 4)
        );

        setInterval(() => {
          this.scroll();
        }, 1000);
      });
  },
  methods: {
    scroll() {
      let liHeight = document.querySelectorAll(".ul_list > li")[0].clientHeight;
      let list = document.querySelectorAll(".ul_list")[0];
      if(this.height >= list.clientHeight - 100){
        this.height = 0
      }
      this.height += liHeight;
      list.style.transform = `translate(0,-${this.height}px)`;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  background: url("~@/assets/image/框C1层.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .list {
    width: 90%;
    height: 90%;
    position: absolute;
    bottom: 0;
    top: 0;
    right: 0;
    left: 0;
    margin: auto;
    z-index: 999;
    background: url("~@/assets/image/框C2层.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    .title {
      position: relative;
      z-index: 999;
      height: 2rem;
      padding: 0;
      // padding-top: 1rem;
      background: transparent;
      z-index: 999;
      width: 100%;
      margin: 0 auto;
      background-color: rgb(3,31,66);
      h2{
        line-height: 2rem;
        margin-left: .625rem;
      }
    }
    .wamp {
      width: 100%;
      display: flex;
      // margin-top: 3rem;
      height: 1rem;
      position: relative;
      z-index: 999;
      li {
        flex: 1;
        text-align: center;
        background: linear-gradient(
          to right,
          rgb(7, 115, 209),
          5%,
          rgb(2, 56, 142),
          95%,
          rgb(2, 56, 142)
        );
        height: 1rem;
        line-height: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        z-index: 999;
      }
    }
    .ul_list {
      width: 100%;
      transition: all 1s;
      li {
        text-align: center;
        display: flex;
        height: 1rem;
        position: relative;
        line-height: 1rem;
        padding: 0.625rem;
        &:nth-child(odd) {
          background-color: rgb(6, 43, 98);
        }
        div {
          flex: 1;
          overflow: hidden;
        }
      }
    }
  }
}
</style>